import { Action } from "redux"

import * as actions from "./actions"
import { IConfirmationDialog } from "./index"

export const initialState: IConfirmationDialog = {
    cancelIcon: "",
    cancelText: "",
    confirmIcon: "",
    confirmText: "",
    isVisible: false,
    title: "",
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: IConfirmationDialog,
        props: Action,
    ) => IConfirmationDialog
} = {
    [actions.INITIALIZE]: (
        state,
        {
            cancelIcon,
            cancelText,
            confirmIcon,
            confirmText,
            title,
        }: actions.Initialize,
    ): IConfirmationDialog => ({
        ...state,
        cancelIcon,
        cancelText,
        confirmIcon,
        confirmText,
        title,
    }),

    [actions.UPDATE_VISIBILITY]: (
        state,
        { isVisible }: actions.UpdateVisibility,
    ): IConfirmationDialog => ({
        ...state,
        isVisible,
    }),
}

export default function reducer(
    state: IConfirmationDialog = initialState,
    action: Action,
): IConfirmationDialog {
    const handler: (
        state: IConfirmationDialog,
        action: Action,
    ) => IConfirmationDialog = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
